import React from 'react';
import { FaListUl, FaExclamationTriangle } from 'react-icons/fa';
import { Card, SectionTitle, CountPill, Spinner, EmptyState } from './Primitives';
import MacroFunctionCard from './MacroFunctionCard';

/**
 * Step 2: elenco delle macrofunzioni recenti. Delega ogni scheda a
 * MacroFunctionCard; qui restano solo layout, stati globali e azioni di
 * selezione multipla dal significato esplicito.
 */
export default function MacroFunctionList({
  items,
  loading,
  error,
  isSelected,
  onToggle,
  onSelectVisible,
  onSelectToGenerate,
  onClearAll,
  selectedCount,
  isExpanded,
  onToggleExpand,
  getDetail,
  onRetryDetail,
}) {
  return (
    <Card className="p-5">
      <SectionTitle
        icon={FaListUl}
        title="Modifiche recenti"
        subtitle="Seleziona le macrofunzioni da rigenerare"
        action={selectedCount > 0 ? <CountPill>{selectedCount} selezionate</CountPill> : null}
      />

      {/* Azioni di selezione multipla — etichette semanticamente chiare */}
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={onSelectVisible}
          disabled={items.length === 0}
          className="rounded-lg border border-gray-300 px-2.5 py-1 text-xs font-medium text-gray-600 hover:border-primary hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-40 dark:border-gray-600 dark:text-gray-300"
        >
          Seleziona visibili
        </button>
        <button
          type="button"
          onClick={onSelectToGenerate}
          disabled={items.length === 0}
          className="rounded-lg border border-gray-300 px-2.5 py-1 text-xs font-medium text-gray-600 hover:border-primary hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-40 dark:border-gray-600 dark:text-gray-300"
          title="Seleziona solo le macrofunzioni mai generate o da rigenerare"
        >
          Seleziona da generare
        </button>
        <button
          type="button"
          onClick={onClearAll}
          disabled={selectedCount === 0}
          className="rounded-lg px-2.5 py-1 text-xs text-gray-500 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-40 dark:hover:bg-gray-700"
        >
          Azzera
        </button>
      </div>

      <div className="mt-4">
        {loading ? (
          <div className="flex items-center gap-2 py-10 text-sm text-gray-500 dark:text-gray-400">
            <Spinner className="h-4 w-4" /> Caricamento modifiche recenti…
          </div>
        ) : error ? (
          <div className="flex items-center gap-2 rounded-xl bg-red-50 p-4 text-sm text-red-700 dark:bg-red-900/30 dark:text-red-300">
            <FaExclamationTriangle size={14} /> {error}
          </div>
        ) : items.length === 0 ? (
          <EmptyState
            icon={FaListUl}
            title="Nessuna macrofunzione"
            hint="Modifica i filtri o l'intervallo temporale per ampliare i risultati."
          />
        ) : (
          <ul className="space-y-2">
            {items.map((item) => (
              <MacroFunctionCard
                key={item.id}
                item={item}
                selected={isSelected(item.id)}
                onToggleSelect={onToggle}
                expanded={isExpanded(item.id)}
                onToggleExpand={onToggleExpand}
                detail={getDetail(item.id)}
                onRetryDetail={onRetryDetail}
              />
            ))}
          </ul>
        )}
      </div>
    </Card>
  );
}
